<template>
  <ValidationProvider
    :rules="validation"
    tag="div"
    class="form-group"
    :vid="id"
    v-slot="{ classes, errors }"
  >
    <label :for="id">
      {{ label }}
      <RequiredMark v-if="required" />
    </label>
    <textarea
      type="text"
      class="form-control"
      :class="classes"
      :id="id"
      v-model="innerValue"
      @input="$emit('input', innerValue)"
    >
    </textarea>
    <div class="invalid-feedback">
      {{ errors[0] }}
    </div>
  </ValidationProvider>
</template>

<script>
import { ValidationProvider } from 'vee-validate';
import { requiredField } from '../mixins/requiredField';
import RequiredMark from './addons/RequiredMark';

export default {
  components: {
    RequiredMark,
    ValidationProvider,
  },
  mixins: [requiredField],
  props: {
    id: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    value: {
      type: [String, Number],
      default: '',
    },
    validation: {
      type: [String, Object],
      default: '',
    },
  },
  data() {
    return {
      innerValue: this.value,
    };
  },
  watch: {
    value(val) {
      this.innerValue = val;
    },
  },
};
</script>
